/**
 * Section title block used at the top of every page.
 * Optional icon + optional right-hand action (usually a primary Button).
 */
import { cn } from '@/lib/utils'

export function PageHeader({ title, subtitle, icon: Icon, action, className }) {
  return (
    <div className={cn('flex items-start justify-between gap-6 mb-8', className)}>
      <div className="flex items-start gap-4">
        {Icon ? (
          <div className="bg-expo-primary text-white p-4 rounded-2xl shadow-md">
            <Icon size={32} />
          </div>
        ) : null}
        <div>
          <h2 className="text-3xl font-bold text-expo-dark tracking-tight">{title}</h2>
          {subtitle ? <p className="text-gray-600 mt-1 text-base">{subtitle}</p> : null}
        </div>
      </div>
      {action}
    </div>
  )
}
